// import icons
import {
    IoLogoFacebook,
    IoLogoInstagram,
    IoLogoWhatsapp,
    IoMdAddCircle,
    IoIosCheckmarkCircle,
    IoIosArrowRoundForward,
} from "react-icons/io";


// import images
import Features1Img from "./assets/images/features-1.png";
import Features2Img from "./assets/images/features-2.png";
import ChairImg from "./assets/images/chair.png";
import BedImg from "./assets/images/bed.png";
import CupboardImg from "./assets/images/cupboard.png";
import Product1Img from "./assets/images/products/product-1.png";
import Product2Img from "./assets/images/products/product-2.png";
import Product3Img from "./assets/images/products/product-3.png";
import Product4Img from "./assets/images/products/product-4.png";
import Product5Img from "./assets/images/products/product-5.png";
import Product6Img from "./assets/images/products/product-6.png";
import Product7Img from "./assets/images/products/product-7.png";
import Product8Img from "./assets/images/products/product-8.png";
import Product9Img from "./assets/images/products/product-9.png";
import Product10Img from "./assets/images/products/product-10.png";
import TestimonialImg from "./assets/images/testimonial.png";
import Avatar1Img from "./assets/images/avatar-1.png";
import Avatar2Img from "./assets/images/avatar-2.png";
import Avatar3Img from "./assets/images/avatar-3.png";

// ===== NAVIGATION =====
export const navigation = [
    {
        name: "home",
        href: "/",
    },
     {
         name: "articles",
        href: "/news",
    },
    {
        name: "about",
        href: "/about",
    },
    {
     name: "breaking",      // ← This name appears in the nav bar
    href: "/breaking",
    },
    {
        name: "latest",
        href: "/latest",
    },
    {
        name: "features",
        href: "/features",
    },
   
    {
        name: "Sign up",
        href: "https://docs.google.com/forms/d/e/1FAIpQLSeVJ-kP4xSZ38a04N0hdbb_-2lSUfK7w-l2uu43Qi23D2cFZg/viewform?usp=dialog",
		external: true,
    },
    {
        name: "contact",
        href: "/contact",
    },
      {
        name: "admin",
        href: "/admin",
    },
];

// ===== HERO =====
export const hero = {
    title: "Kohla News - Okara Ki Awaz, Punjab Ki Pehchan",
    subtitle:
        "Visit our website or contact us on WhatsApp for breaking news, local updates, political coverage, agriculture news, sports, and complete news coverage from Okara, Punjab, Pakistan, and around the world.",
    buttonText: "Contact to Whatsapp"
};

// ===== STATS =====
export const stats = [
    {
        value: "10K+",
        text: "Daily Viewers",
    },
    {
        value: "24/7",
        text: "News Coverage",
    },
    {
        value: "50K+",
        text: "Social Followers",
    },
    {
        value: "100%",
        text: "Trusted News",
    },
];




// ===== FEATURES =====
export const features = {
    image: <Features1Img />,
    title: "Delivering News That Matters to You",
    subtitle:
        "For many years, Kohla News has been providing accurate, timely, and reliable news coverage for Okara, Punjab, Pakistan, and international audiences.",
    buttonText: "Explore News",
    items: [
        {
            icon: <IoIosCheckmarkCircle />,
            title: "Okara & Punjab News",
            subtitle:
                "We cover local news from Okara, Depalpur, Renala Khurd, and complete Punjab province coverage.",
        },
        {
            icon: <IoIosCheckmarkCircle />,
            title: "Pakistan & International News",
            subtitle:
                "Our team provides national news from Pakistan, international affairs, global politics, economy updates.",
        },
    ],
    feature2: {
        image: <Features2Img />,
        title: "Breaking News - First and Fastest",
        subtitle:
            "Kohla News has proudly served viewers in Okara and across Pakistan with quality journalism, reliable reporting.",
    },
};



// ===== NEW IN STORE =====
export const newInStore = {
    title: "Trending News",
    subtitle: "Get the latest trending stories immediately",
    link: "View All",
    icon: <IoIosArrowRoundForward />,
    products: [
        { name: "Politics", image: <ChairImg /> },
        { name: "Sports", image: <BedImg /> },
        { name: "Agriculture", image: <CupboardImg /> },
        { name: "Weather", image: <ChairImg /> },
    ],
};

// ===== PRODUCTS =====
export const products = {
    title: "Top Stories",
    subtitle: "The top stories we provide only for you",
    pages: [
        {
            productList: [
                {
                    image: <Product1Img />,
                    icon: <IoMdAddCircle />,
                    name: "Political Update Pakistan",
                    price: 75,
                    oldPrice: 82,
                },
                {
                    image: <Product2Img />,
                    icon: <IoMdAddCircle />,
                    name: "Okara Local News",
                    price: 50,
                    oldPrice: 70,
                },
                {
                    image: <Product3Img />,
                    icon: <IoMdAddCircle />,
                    name: "Punjab Government Updates",
                    price: 105,
                    oldPrice: 120,
                },
                {
                    image: <Product4Img />,
                    icon: <IoMdAddCircle />,
                    name: "Agriculture News",
                    price: 75,
                    oldPrice: 82,
                },
                {
                    image: <Product5Img />,
                    icon: <IoMdAddCircle />,
                    name: "International Affairs",
                    price: 200,
                    oldPrice: 210,
                },
                {
                    image: <Product6Img />,
                    icon: <IoMdAddCircle />,
                    name: "Sports Coverage",
                    price: 45,
                    oldPrice: 50,
                },
                {
                    image: <Product7Img />,
                    icon: <IoMdAddCircle />,
                    name: "Weather Updates",
                    price: 320,
                    oldPrice: 325,
                },
                {
                    image: <Product8Img />,
                    icon: <IoMdAddCircle />,
                    name: "Business & Economy",
                    price: 225,
                    oldPrice: 240,
                },
                {
                    image: <Product9Img />,
                    icon: <IoMdAddCircle />,
                    name: "Education News",
                    price: 105,
                    oldPrice: 120,
                },
                {
                    image: <Product10Img />,
                    icon: <IoMdAddCircle />,
                    name: "Health Updates",
                    price: 75,
                    oldPrice: 82,
                },
            ],
        },
        {
            productList: [
                {
                    image: <Product7Img />,
                    icon: <IoMdAddCircle />,
                    name: "Breaking News Alert",
                    price: 320,
                    oldPrice: 325,
                },
                {
                    image: <Product8Img />,
                    icon: <IoMdAddCircle />,
                    name: "Political Analysis",
                    price: 225,
                    oldPrice: 240,
                },
                {
                    image: <Product9Img />,
                    icon: <IoMdAddCircle />,
                    name: "Okara Development",
                    price: 105,
                    oldPrice: 120,
                },
                {
                    image: <Product10Img />,
                    icon: <IoMdAddCircle />,
                    name: "Punjab Politics",
                    price: 75,
                    oldPrice: 82,
                },
                {
                    image: <Product1Img />,
                    icon: <IoMdAddCircle />,
                    name: "International Relations",
                    price: 75,
                    oldPrice: 82,
                },
                {
                    image: <Product2Img />,
                    icon: <IoMdAddCircle />,
                    name: "Cricket News",
                    price: 50,
                    oldPrice: 70,
                },
                {
                    image: <Product3Img />,
                    icon: <IoMdAddCircle />,
                    name: "Weather Forecast",
                    price: 105,
                    oldPrice: 120,
                },
                {
                    image: <Product4Img />,
                    icon: <IoMdAddCircle />,
                    name: "Mandi Rates",
                    price: 75,
                    oldPrice: 82,
                },
                {
                    image: <Product5Img />,
                    icon: <IoMdAddCircle />,
                    name: "Economic Update",
                    price: 200,
                    oldPrice: 210,
                },
                {
                    image: <Product6Img />,
                    icon: <IoMdAddCircle />,
                    name: "Health & Education",
                    price: 200,
                    oldPrice: 210,
                },
            ],
        },
    ],
};
// ===== LATEST NEWS DATA =====
export const news = {
    title: "Latest News Headlines",
    subtitle: "Breaking news, top stories, and updates from Okara, Punjab, Pakistan, and around the world",
    pages: [
        {
            newsList: [
                {
                    title: "BREAKING: Major Political Development in Punjab",
                    category: "Politics",
                    time: "2 hours ago",
                    views: "15.2K",
                    icon: "🏛️",
                },
                {
                    title: "Okara Mandi Rates See Significant Increase in Wheat Prices",
                    category: "Agriculture",
                    time: "4 hours ago",
                    views: "8.7K",
                    icon: "🌽",
                    iconSize: "text-12x2",
                    
                },
                {
                    title: "New Development Projects Announced for Depalpur Tehsil",
                    category: "Local Okara",
                    time: "5 hours ago",
                    views: "6.3K",
                    icon: "📢",
                },
                {
                    title: "National Assembly Passes Key Economic Reform Bill",
                    category: "Pakistan",
                    time: "6 hours ago",
                    views: "12.1K",
                    icon: "🕌",
                },
                {
                    title: "Pakistan-China Relations Strengthen with New Trade Agreements",
                    category: "International",
                    time: "8 hours ago",
                    views: "9.8K",
                    icon: "🌍",
                },
                {
                    title: "Weather Update: Rain Expected in Punjab This Week",
                    category: "Weather",
                    time: "10 hours ago",
                    views: "4.5K",
                    icon: "🌤️",
                },
                {
                    title: "Punjab Government Announces New Education Initiatives",
                    category: "Politics",
                    time: "12 hours ago",
                    views: "7.2K",
                    icon: "🔔",
                },
                {
                    title: "Pakistan Cricket Team Prepares for Upcoming International Series",
                    category: "Sports",
                    time: "14 hours ago",
                    views: "11.5K",
                    icon: "⚾",
                },
                {
                    title: "Okara DHQ Hospital Gets New Medical Equipment",
                    category: "Local Okara",
                    time: "16 hours ago",
                    views: "3.8K",
                    icon: "💊",
                },
                {
                    title: "Inflation Rate Shows Slight Decline in Pakistan",
                    category: "Pakistan",
                    time: "18 hours ago",
                    views: "10.3K",
                    icon: "🕌",
                },
            ],
        },
        {
            newsList: [
                {
                    title: "Middle East Peace Talks: Pakistan's Role as Mediator",
                    category: "International",
                    time: "1 day ago",
                    views: "14.7K",
                    icon: "🌍",
                },
                {
                    title: "Punjab Chief Minister Announces Development Package for Rural Areas",
                    category: "Politics",
                    time: "1 day ago",
                    views: "9.2K",
                    icon: "🗳️",
                },
                {
                    title: "Farmers in Okara Welcome New Government Subsidies",
                    category: "Agriculture",
                    time: "1 day ago",
                    views: "6.8K",
                    icon: "🌽",
                },
                {
                    title: "BREAKING: Important Court Verdict on Key Political Case",
                    category: "Breaking News",
                    time: "1 day ago",
                    views: "28.3K",
                    icon: "🔴",
                },
                {
                    title: "Renala Khurd Gets New Community Park and Sports Complex",
                    category: "Local Okara",
                    time: "1 day ago",
                    views: "4.1K",
                    icon: "🕌",
                },
                {
                    title: "Weather Alert: Heatwave Expected in Southern Punjab",
                    category: "Weather",
                    time: "1 day ago",
                    views: "5.6K",
                    icon: "🌤️",
                },
                {
                    title: "Local Okara Cricket Tournament Draws Large Crowds",
                    category: "Sports",
                    time: "1 day ago",
                    views: "3.9K",
                    icon: "🏏",
                },
                {
                    title: "Supreme Court Hearing on Key Constitutional Case",
                    category: "Pakistan",
                    time: "1 day ago",
                    views: "16.5K",
                    icon: "🇵🇰",
                },
                {
                    title: "Global Oil Prices Drop - Impact on Pakistani Economy",
                    category: "International",
                    time: "1 day ago",
                    views: "8.9K",
                    icon: "🌍",
                },
                {
                    title: "Okara Chamber of Commerce Elects New Leadership",
                    category: "Local Okara",
                    time: "1 day ago",
                    views: "2.7K",
                    icon: "🏘️",
                },
            ],
        },
    ],
};
// ===== TESTIMONIAL =====
export const testimonial = {
    title: "What people are saying about Kohla News",
    image: <TestimonialImg />,
    persons: [
        {
            avatar: <Avatar1Img />,
            name: "Ahmed Raza",
            occupation: "Okara Resident",
            message:
                "“Kohla News is the most reliable source for local news in Okara. I trust them for accurate and timely updates.”",
        },
        {
            avatar: <Avatar2Img />,
            name: "Fatima Noor",
            occupation: "University Student",
            message:
                "“The coverage of education and youth issues is outstanding. They truly represent the voice of the people.”",
        },
        {
            avatar: <Avatar3Img />,
            name: "Rimsha",
            occupation: "Businessman, Depalpur",
            message:
                "“I appreciate their fair and balanced reporting on business and agriculture news. Highly recommended!”",
        },
    ],
};

// ===== NEWSLETTER =====
export const newsletter = {
    title: "Subscribe to Kohla News Updates",
    subtitle: "Get daily news alerts delivered to your inbox",
    placeholder: "Your email address",
    buttonText: "Subscribe Now",
};

// ===== BUSINESS INFO =====
export const business = {
    name: "Kohla News",
    shortName: "Kohla",
    category: "News Channel",
    whatsapp: "0300-0000000",
    whatsappLink: "https://wa.me/923000000000",
    youtube: "https://youtube.com/@kohlanews",  // ← Your channel
    tiktok: "https://www.tiktok.com/@kohla.news",
    facebook: "https://www.facebook.com/share/1UevAhRtCr/",
    instagram: "https://www.instagram.com/kohlanews",
    phone: "0300-0000000",
    email: "kohlanews@gmail.com",
    address: "Kohla News, Okara, Punjab, Pakistan",
    mapLink: "https://maps.app.goo.gl/PM241B65k5mMyjJE8",
};


// ===== FOOTER =====
export const footer = {
    social: [
        {
            icon: <IoLogoWhatsapp />,
            href: business.whatsappLink,
        },
        {
            icon: <IoLogoInstagram />,
            href: business.instagram,
        },
        {
            icon: <IoLogoFacebook />,
            href: business.facebook,
        },
    ],
    copyright: "Kohla News 2026 - All Rights Reserved.",
};